import { Cohort } from "../constants/rootConstants";

export const getPathFromPageId = ({ cohort, pageId }: {
    cohort: Cohort
    pageId: string
}): string => {
    return `${cohort}/${ pageId }`
}
